"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderOnBehalfDialog = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _ChangeConsultantForm = require("../ChangeConsultantForm");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OrderOnBehalfDialog = ({
  vipAccessData,
  vipAccessLabels,
  open,
  close
}) => {
  const [changeOpened, setChangeOpened] = (0, _react.useState)(false);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onChangeOpened = (0, _react.useCallback)(value => () => {
    setChangeOpened(value);
  }, []);
  const header = (0, _react.useMemo)(() => {
    if (changeOpened) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BackArrow, {
          "data-testid": getTestId(_constants.ORDER_ON_BEHALF_DIALOG_BACK_ARROW),
          onClick: onChangeOpened(false),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h5",
          component: "h5",
          children: vipAccessLabels.ConsultantChangeConsultantNumber
        })]
      });
    }
    return undefined;
  }, [changeOpened, getTestId, onChangeOpened, vipAccessLabels.ConsultantChangeConsultantNumber]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
    "data-testid": getTestId(_constants.ORDER_ON_BEHALF_DIALOG),
    header: header,
    open: open,
    hideCloseButton: changeOpened,
    onClose: close,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopupContentGroup, {
      children: changeOpened ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChangeConsultantForm.ChangeConsultantForm, {
        vipAccessLabels: vipAccessLabels
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopupButton, {
          fullWidth: true,
          variant: "contained",
          color: "primary",
          href: vipAccessData.Links[0]?.Url,
          children: vipAccessData.Links[0]?.Text
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopupButton, {
          fullWidth: true,
          variant: "contained",
          color: "primary",
          onClick: onChangeOpened(true),
          children: vipAccessLabels.ConsultantChangeConsultantNumber
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopupLink, {
          variant: "button",
          color: "primary",
          href: vipAccessData.Links[2]?.Url,
          children: vipAccessData.Links[2]?.Text
        })]
      })
    })
  });
};
exports.OrderOnBehalfDialog = OrderOnBehalfDialog;
